import Http from "../util/Http";
import { uploadImageFile } from "../util/ImageService";

class UserApi {

    static async duplCheck(userId) {
        const res = await Http.post('/user/idDuplicate', { userId });
        return res || null;
    }

    static async duplNicknmCheck(userNicknm) {
        const res = await Http.post('/user/nicknmDuplicate', { userNicknm });
        return res || null;
    }

    static async emailCheck(userEmail) {
        const res = await Http.post('/user/validEmail', { userEmail });
        return res || null;
    }

    static async join(user) {
        const res = await Http.post('/user/join', user)
        return res || null;
    }

    static async getUsers() {
        const res = await Http.get('/user/list')
        return res || null;
    }

    static async updateUserInfo(data) {
        const res = await Http.post('/user/update', data);
        return res || null;
    }

    static async getMyInfo() {
        const res = await Http.get('/user/myinfo');
        return res || null;
    }
    
    static async getUserLoginInfo() {
        const res = await Http.get('/user/loginInfo');
        return res || null;
    }

    static async logout() {
        const res = await Http.get('/user/logout');
        return res || null;
    }

    static async findUserInfo(info) {
        const res = await Http.post('/user/find', info);
        return res || {};
    }

    static async loginByKakao(accessToken) {
        const res = await Http.post('/user/auth/kakao', { accessToken });
        return res || {};
    }

    static async loginByGoogle(credential) {
        const res = await Http.post('/user/auth/google', { credential });
        return res || {};
    }

    static async updateUserProfileImg(formData) {
        const file = formData.get('userProfileImg');
        if (!file) {
            return { code: 'fail', message: '파일이 없습니다.' };
        }
        return uploadImageFile(file, 'profile', 'userProfileImg');
    }

    static async getExpertInfo(userId) {
        const res = await Http.get(`/user/${userId}/expert-info`);
        return res || null;
    }
}

export default UserApi;